import { Entity } from '@debbie/common/dist/index.js';
import { InteractionEventType, } from '@debbie/common/dist/interactions/events/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../../../theme.js';
import Alert from '../../../Alert.js';
import CasePreview from '../../../CasePreview/CasePreview.js';
import Col from '../../../Grid/Col.js';
import Row from '../../../Grid/Row.js';
import Shield from '../../../Icons/Shield.js';
import PerformedBy from '../../../performed-by/PerformedBy.js';
import Well from '../../../Well.js';
import { Box } from '../Helpers.js';
const CommonEventCmp = (props) => {
    switch (props.event.type) {
        case InteractionEventType.Journaled:
            return React.createElement(JournaledEventCmp, { event: props.event });
        case InteractionEventType.Copied:
            return React.createElement(CopiedEventCmp, { event: props.event });
        case InteractionEventType.Clicked:
            return React.createElement(ClickedEventCmp, { event: props.event });
        case InteractionEventType.SendingApproved:
            return React.createElement(SendingApprovedEventCmp, { event: props.event });
        default:
            return null;
    }
};
export default CommonEventCmp;
const JournaledEventCmp = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    if (event.type !== InteractionEventType.Journaled) {
        throw 'Invalid event type';
    }
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } },
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                        } }),
                    ' ',
                    event.data.referenceId
                        ? lang.interactions.journaled
                        : lang.interactions.unjournaled),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: event.data.referenceId
                    ? lang.interactions.journaledBy
                    : lang.interactions.unjournaledBy, body: React.createElement(PerformedBy, { performedBy: event.performedBy }) }),
            React.createElement(Box, { header: lang.interactions.at, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) })),
        event.data.referenceType === Entity.Case && event.data.referenceId && (React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.onCase, body: React.createElement(CasePreview, { caseId: event.data.referenceId }) })))));
};
const CopiedEventCmp = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    if (event.type !== InteractionEventType.Copied) {
        throw 'Invalid event type';
    }
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.copiedBy, body: React.createElement(PerformedBy, { performedBy: event.performedBy }) }),
            React.createElement(Box, { header: lang.interactions.at, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) })),
        React.createElement(Row, null,
            event.data.to && event.data.referenceType === Entity.Case && (React.createElement(Box, { header: lang.interactions.toCase, body: React.createElement(CasePreview, { caseId: event.data.to.referenceId }) })),
            event.data.from && event.data.referenceType === Entity.Case && (React.createElement(Box, { header: lang.interactions.fromCase, body: React.createElement(CasePreview, { caseId: event.data.from.referenceId }) })))));
};
const SendingApprovedEventCmp = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactionEventTypes[InteractionEventType.SendingApproved], body: React.createElement(PerformedBy, { performedBy: event.performedBy }) }),
            React.createElement(Box, { header: lang.interactions.at, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }))));
};
const ClickedEventCmp = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } }, lang.interactionEventTypes[InteractionEventType.Clicked]),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.openedAt, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }),
            event.data.geoIp && (React.createElement(Box, { header: "Geo IP", body: event.data.geoIp?.zipcode && event.data.geoIp?.city ? (React.createElement(React.Fragment, null,
                    event.data.geoIp?.zipcode,
                    " ",
                    event.data.geoIp?.city,
                    ",",
                    ' ',
                    event.data.geoIp?.country)) : (React.createElement(React.Fragment, null,
                    "Long. ",
                    event.data.geoIp?.longitude,
                    ", lat.",
                    ' ',
                    event.data.geoIp?.latitude)) })),
            event.data.ip && React.createElement(Box, { header: 'IP', body: event.data.ip })),
        event.data.userAgent && (React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.userAgent, body: event.data.userAgent })))));
};
//# sourceMappingURL=CommonEvents.js.map